import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.25195 12.5H8.75195V11H7.25195V12.5ZM8.00195 0.5C3.86195 0.5 0.501953 3.86 0.501953 8C0.501953 12.14 3.86195 15.5 8.00195 15.5C12.142 15.5 15.502 12.14 15.502 8C15.502 3.86 12.142 0.5 8.00195 0.5ZM8.00195 14C4.69445 14 2.00195 11.3075 2.00195 8C2.00195 4.6925 4.69445 2 8.00195 2C11.3095 2 14.002 4.6925 14.002 8C14.002 11.3075 11.3095 14 8.00195 14ZM8.00195 3.5C6.34445 3.5 5.00195 4.8425 5.00195 6.5H6.50195C6.50195 5.675 7.17695 5 8.00195 5C8.82695 5 9.50195 5.675 9.50195 6.5C9.50195 8 7.25195 7.8125 7.25195 10.25H8.75195C8.75195 8.5625 11.002 8.375 11.002 6.5C11.002 4.8425 9.65945 3.5 8.00195 3.5Z",
		fill: "#BDB8FF"
	})
});
export { SvgHelp as ReactComponent };
